import encontrosService from "@/service/encontrosService";
import { usePagination } from "@/composables/usePagination";
import { ref } from "vue";

export function useEncontros() {
  const encontros = ref([]);
  const participacoes = ref([]);
  const isLoading = ref(false);
  const isSaving = ref(false);
  const isDownloading = ref(false);

  const pagination = usePagination({
    initialPage: 0,
    pageSize: 10,
    baseIndex: 0,
  });

  const fetchEncontros = async (
    page = pagination.currentPage.value,
    size = pagination.pageSize.value,
    atividadeId
  ) => {
    isLoading.value = true;
    try {
      const response = await encontrosService.getEncontros(
        page,
        size,
        atividadeId
      );
      encontros.value = response || [];
      pagination.currentPage.value = page;
      return response;
    } catch (error) {
      console.error("Erro ao buscar encontros:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const createEncontro = async (atividadeId, dadosEncontro) => {
    isSaving.value = true;
    try {
      const response = await encontrosService.postUmEncontro(
        atividadeId,
        dadosEncontro
      );
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar encontro:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const createMuitosEncontros = async (atividadeId, listaEncontros) => {
    isSaving.value = true;
    try {
      const response = await encontrosService.postMuitosEncontros(
        atividadeId,
        listaEncontros
      );
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar múltiplos encontros:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const updateEncontro = async (encontroId, dadosEncontro) => {
    isSaving.value = true;
    try {
      const response = await encontrosService.putEncontro(
        encontroId,
        dadosEncontro
      );
      return response;
    } catch (error) {
      console.error("Erro ao atualizar encontro:", error);
    } finally {
      isSaving.value = false;
    }
  };

  const deleteEncontro = async (encontroId) => {
    isLoading.value = true;
    try {
      const response = await encontrosService.deletEncontro(encontroId);
      return response;
    } catch (error) {
      console.error("Erro ao deletar encontro:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const cancelEncontro = async (encontroId, motivo) => {
    isLoading.value = true;
    try {
      const response = await encontrosService.cancelarEncontro(
        encontroId,
        motivo
      );
      return response;
    } catch (error) {
      console.error("Erro ao cancelar encontro:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const fetchParticipacoes = async (
    page = pagination.currentPage.value,
    size = pagination.pageSize.value,
    atividadeId,
    participanteId
  ) => {
    isLoading.value = true;
    try {
      const response = await encontrosService.participacoesEncontro(
        page,
        size,
        atividadeId,
        participanteId
      );
      participacoes.value = response || [];
      pagination.currentPage.value = page;
      return response;
    } catch (error) {
      console.error("Erro ao buscar participações no encontro:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const concluirEncontro = async (encontroId) => {
    isLoading.value = true;
    try {
      const response = await encontrosService.concluirEncontro(encontroId);
      return response;
    } catch (error) {
      console.error("Erro ao concluir encontro:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  const downloadListaAssinatura = async (encontroId) => {
    isDownloading.value = true;
    try {
      const response =
        await encontrosService.downloadListaAssinatura(encontroId);
      return response;
    } catch (error) {
      console.error("Erro ao baixar lista de assinatura:", error);
      throw error;
    } finally {
      isDownloading.value = false;
    }
  };

  return {
    encontros,
    participacoes,
    isLoading,
    isLoadingEncontro: isLoading,
    isSaving,
    isSavingEncontro: isSaving,
    isDownloading,
    currentPage: pagination.currentPage,
    totalPages: pagination.totalPages,
    pageSize: pagination.pageSize,
    hasNextPage: pagination.hasNextPage,
    hasPreviousPage: pagination.hasPreviousPage,
    fetchEncontros,
    createEncontro,
    createMuitosEncontros,
    updateEncontro,
    deleteEncontro,
    cancelEncontro,
    fetchParticipacoes,
    concluirEncontro,
    downloadListaAssinatura,
    nextPage: pagination.nextPage,
    previousPage: pagination.previousPage,
    goToPage: pagination.goToPage,
  };
}
